import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

export default styled(Flexer.Parent)`
  width: 100%;
  flex-wrap: wrap;
`;
